import React from "react";
import { useLocation } from "react-router-dom";

// Components
import DynamicInsuranceCoverage from "components/DynamicInsuranceCoverage";
import PageHeader from "components/CBPageHeader";
import SEO from "components/CBSEO";
import InsuranceFaqContainer from "../../components/InsuranceFaqContainer";
import Page404 from "pages/404";
import SchemaComponent from "components/CBSchema";

// Styled Components
import { StyledMainPageContainer } from "index.styles";
import { StyledSectionBackgroundWrapper } from "index.styles";

// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";

// Data
import ketamineTherapySeoData from "./data/seoData/ketamineTherapySeo.data.json";
import ketamineTherapySchemaData from "./data/schemaData/ketamineTherapySchema.data.json";
import ketamineTherapyFaqData from "./data/faqData/ketamineTherapyFaq.data.json";

// Coverage Data
import ketamineTherapyCoverageData from "./data/coverageData/ketamineTherapyCoverage.data.json";

// Content mapping for different modality types
const modalityContentMap = {
  "ketamine-therapy": {
    seoData: ketamineTherapySeoData,
    schemaData: ketamineTherapySchemaData,
    faqData: ketamineTherapyFaqData,
    coverageData: ketamineTherapyCoverageData,
    header: "Insurance Options for \\n Ketamine-Assisted Therapy",
    headerAccent: "Ketamine-Assisted Therapy",
    section: "ketamine-therapy-insurance-options",
  },
};

const InsuranceOptionsDynamic = () => {
  const path = useLocation();

  // Check if modality type is valid
  if (!modalityContentMap[path.pathname.split("/")[1]]) {
    return <Page404 />;
  }

  const content = modalityContentMap[path.pathname.split("/")[1]];
  const schemaData = constructSchemaData(content.schemaData.url, content.schemaData.breadcrumbs);

  return (
    <StyledMainPageContainer id={`${path.pathname.split("/")[1]}-insurance-options-page`}>
      <SchemaComponent schemas={schemaData} />
      <SEO title={content.seoData.title} description={content.seoData.description} canonicalUrl={content.seoData.canonicalUrl} />
      <StyledSectionBackgroundWrapper>
        <PageHeader header={content.header} headerAccent={content.headerAccent} lightText="true" section={content.section} />
      </StyledSectionBackgroundWrapper>

      <DynamicInsuranceCoverage coverageData={content.coverageData} />
      <InsuranceFaqContainer faqData={content.faqData} />
    </StyledMainPageContainer>
  );
};

export default InsuranceOptionsDynamic;
